import { Component, OnInit, Renderer2 } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { TournamentsService } from "src/app/services/tournamnet.service";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from "@angular/forms";
import { ConfirmationService, MessageService } from "primeng/api";
import { environment } from "src/environments/environment";
@Component({
  selector: "app-tournament-result",
  templateUrl: "./tournament-result.component.html",
  styleUrls: ["./tournament-result.component.scss"],
  providers: [ConfirmationService, MessageService],
})
export class TournamentResultComponent implements OnInit {
  public tournamentId;
  public loggedInAcademy;
  public loggedInAcademyId;
  public isTournamentDrawView: boolean = false;
  public categoryId;
  public ageGroupId;
  public categoryList: any = [];
  public ageGroupList: any = [];
  public selectedGroupId;
  categoryForm: FormGroup;
  loading: boolean;
  public selectedAgeGroupId;
  public tournamentCategoryId;
  public publishStatus: boolean = true;
  public showPublish: boolean = false;
  public tournamentResult;
  public showEmpty: boolean = false;
  tournamentname: any;
  totalRecords: 0;
  item: any;
  public courtTypeList = environment.courtTypeList;
  courttype: any;
  doublecatarray: any[] = [];
  public hideRating: boolean = false;
  categoryAndAgeGroupList: any;

  constructor(
    private renderer: Renderer2,
    private activatedRoute: ActivatedRoute,
    private tokenStorageService: TokenStorageService,
    private tournamentService: TournamentsService,
    private formBuilder: FormBuilder,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.tournamentId = this.activatedRoute.snapshot.paramMap.get("id");
    this.loggedInAcademy = this.tokenStorageService.getUser();

    if (Object.keys(this.loggedInAcademy).length > 0) {
      this.loggedInAcademyId = this.loggedInAcademy.userdata["academyId"];
      let academyPaymentDetails =
        this.loggedInAcademy.userdata.academyPaymentDetails;
      if (this.loggedInAcademyId == undefined) {
        this.isTournamentDrawView = false;
      } else {
        this.isTournamentDrawView = true;
      }
    }
    this.categoryForm = this.formBuilder.group({
      // categoryType: ["", [Validators.required]],
      // ageGroup: ["", [Validators.required]],
      categoryAndAgeGroup: ['', [Validators.required]]
    });
    this.tournamentService.findBySlug().subscribe((data) => {
      this.doublecatarray = data;
    });
    let category = this.tournamentService.getCategory();
    if (category != "") {
      this.categoryId = category["categoryId"];
      this.ageGroupId = category["ageGroupId"];
      this.showPublish = true;
      if (this.doublecatarray.includes(this.categoryId)) {

        this.hideRating = true
  
      } else {
        this.hideRating = false
  
      }
      //this.getDrawResult(this.tournamentId, this.categoryId, this.ageGroupId);
    }

    // this.getTournamentCategory(this.tournamentId);
    this.getTournamentCategoryV2(this.tournamentId);
    this.getTournamentsDetails();
    this.renderer.addClass(document.body, "mobile-bodylightGrey");
    
  }
  ngOnDestroy() {
    this.renderer.removeClass(document.body, "mobile-bodylightGrey");
  }
  getDrawResult(tournamentId, categoryId, ageGroupId) {
    let query;
    query =
      "filterByTournamentId=" +
      tournamentId +
      "&filterByMatchId=" +
      categoryId +
      "&filterByAgeGroup=" +
      ageGroupId;
    if (this.isTournamentDrawView) {
      //query += "&filterByPublishStatus=true";
    } else {
      //query += "&filterByPublishStatus=true";
    }
    this.loading = true;
    this.tournamentService.getDrawResult(query).subscribe(
      //this.tournamentService.getDrawResult(tournamentId,categoryId,ageGroupId).subscribe(
      (data) => {
        this.tournamentResult = data["data"];
        if (this.tournamentResult?.length > 0) {
          this.totalRecords = this.tournamentResult.length;
          this.showEmpty = false;
          let index = 1;
          const rating = this.tournamentResult.forEach((player) => {
            const playerRating = player.latestRecord.playerRating;
            // const oldPlayerRating = player.latestRecord.oldplayerRating;
            // if (playerRating > oldPlayerRating) {
            //   let addition = playerRating - oldPlayerRating;
            //   player.latestRecord.difference = addition;
            //   player.latestRecord.showclass = true;
            // } else {
            //   let subtraction = playerRating - oldPlayerRating;
            //   player.latestRecord.difference = subtraction;
            //   player.latestRecord.showclass = false;
            // }
            const oldplayerLastRating = player.latestRecord.oldplayerLastRating;
            if (playerRating > oldplayerLastRating) {
              let addition = playerRating - oldplayerLastRating;
              player.latestRecord.difference = addition;
              player.latestRecord.showclass = true;
            } else {
              let subtraction = playerRating - oldplayerLastRating;
              player.latestRecord.difference = subtraction;
              player.latestRecord.showclass = false;
            }
            player.latestRecord.serial = index++;
          });
          this.loading = false;
        } else {
          this.loading = false;
          this.totalRecords = 0;
        }
      }
    );
  }
  getTournamentsDetails() {
    //console.log("zzz", id);
    this.tournamentService
      .getTournamentsDetails(this.tournamentId)
      .subscribe((res) => {
        this.item = res;
        this.tournamentname = res.name;
        // this.academyName = res.academyName;
        // this.cityname = res.cityname;
        // this.statename = res.statename;
        // this.zipcode = res.zipcode;
        // this.countryname = res.countryname;
        // this.organizercontactnumber = res.organizercontactnumber;
        // this.whatsAppgrouplink = res.whatsAppgrouplink;
        // this.tournamentCategories = res.tournamentCategories;
        // this.regulations = res.regulations;
        // this.sponsor_logo = res.sponsor_logo;
        this.courtTypeList.forEach((element) => {
          if (element.value == res.courttype) {
            this.courttype = element.label;
          }
        });
      });
  }
  async getTournamentCategory(id) {
    let query = "getMatchtype=true";
    this.tournamentService.getTournamentCategory(id, query).subscribe(
      (data) => {
        if (data) {
          this.categoryList = data.items;
          this.categoryList.forEach((element) => {
            if (element.matchTypeId === this.categoryId) {
              this.categoryForm.controls.categoryType.setValue(element);
              let event = {
                value: {
                  matchTypeId: element.matchTypeId,
                },
              };
              this.onSelectCategory(event);
            }
          });
        }
      },
      (err) => { }
    );
  }

  async getTournamentCategoryV2(id) {
    this.tournamentService.getTournamentCategoryV2(id).subscribe(
      data => {
        if (data) {
          this.categoryAndAgeGroupList = data;
        }
      },
      (err) => {
      }
    );
  }

  onSelectCategory(event) {

    this.selectedGroupId = event.value.matchTypeId;
    if (this.doublecatarray.includes(this.selectedGroupId)) {

      this.hideRating = true

    } else {
      this.hideRating = false

    }
    let query = "getAgeGroup=true&matchtype=" + event.value.matchTypeId;
    this.tournamentResult = [];
    this.showEmpty = true;
    //this.categoryId='';
    this.tournamentService
      .getTournamentCategory(this.tournamentId, query)
      .subscribe(
        (data) => {
          this.ageGroupList = [];
          this.publishStatus = true;
          if (data) {
            this.ageGroupList = data.items;
            this.ageGroupList.forEach((element) => {
              if (element.ageGroupId === this.ageGroupId) {
                this.categoryForm.controls.ageGroup.setValue(element);
                this.publishStatus = element.publishStatus;
                this.tournamentCategoryId = element.tournamentCategoryId;
                this.getDrawResult(
                  this.tournamentId,
                  this.categoryId,
                  this.ageGroupId
                );
              }
            });
            //this.getDrawResult(this.tournamentId, this.categoryId, this.ageGroupId);
          }
        },
        (err) => { }
      );
  }
  onAgeGroupSelect(event) {
    this.selectedAgeGroupId = event.value.ageGroupId;
    if (event.value.drawStatus && !event.value.publishStatus) {
      this.showPublish = true;
    } else {
      this.showPublish = false;
    }
    this.publishStatus = event.value.publishStatus;
    this.tournamentCategoryId = event.value.tournamentCategoryId;
    this.tournamentResult = [];
    this.getDrawResult(
      this.tournamentId,
      this.selectedGroupId,
      this.selectedAgeGroupId
    );
  }

  onselectGetCategoryV2(event) {
    this.selectedGroupId = event.value.matchTypeId;
    this.selectedAgeGroupId = event.value.ageGroupId;
    if (event.value.drawStatus && !event.value.publishStatus) {
      this.showPublish = true;
    } else {
      this.showPublish = false;
    }
    this.publishStatus = event.value.publishStatus;
    this.tournamentCategoryId = event.value.tournamentCategoryId;
    this.tournamentResult = [];
    this.getDrawResult(
      this.tournamentId,
      this.selectedGroupId,
      this.selectedAgeGroupId
    );
  }

  onClickPublishButton() {
    this.confirmationService.confirm({
      message: "Are you sure you want to publish this Tournament Result?",
      header: "Confirm",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        let publishStatus = true;
        let tournamentCategoryData = '{"publishStatus":' + publishStatus + "}";
        this.tournamentService.sendCategory({
          categoryId: this.selectedGroupId,
          ageGroupId: this.selectedAgeGroupId,
        });
        this.tournamentService
          .saveDraw(this.tournamentCategoryId, tournamentCategoryData)
          .subscribe(
            (data) => {
              //this.router.navigate(['result/' + this.tournamentId]);
              this.showPublish = false;
              this.messageService.add({
                key: "toastmsg",
                severity: "success",
                summary: "Successful",
                detail: "Tournament Result Published Successfully",
                life: 6000,
              });
            },
            (err) => {
              this.messageService.add({
                key: "toastmsg",
                severity: "error",
                summary: "Error",
                detail: err.error.message,
                life: 6000,
              });
            }
          );
      },
      reject: () => { },
    });
  }
}
